// Vendors
import $ from 'jquery';

// Force anchor links to open in parent within preview iframe
$('html').on('click', 'a', (event) => {
  if (!$('html').hasClass('html--is-preview')) return;

  const element = $(event.currentTarget);
  const href = element.attr('href');
  const target = element.attr('target');

  // Bail if the target is blank
  // or if the link is to the current page
  if (target === '_blank') return;
  if (href.indexOf(window.location.href) === 0) return;
  if (href.indexOf('#') === 0) return;

  event.preventDefault();
  window.open(element.attr('href'), '_blank');
  return;
});
